// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Aufmaß pages. Page rules are scoped to .measurements-page; the photo drawer
   (.photo-measure) and the AR overlay (.ar-overlay) render outside the page. */

.measurements-page .ms-small,
.photo-measure .pm-small {
  color: var(--ds-text-muted);
  font-size: 12px;
}

.measurements-page .ms-full,
.photo-measure .pm-full {
  width: 100%;
}

.measurements-page .ms-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

/* Header */
.measurements-page .ms-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-4);
}

.measurements-page .ms-title-input {
  flex: 1;
  min-width: 0;
  font-family: var(--ds-font-display);
  font-weight: 600;
}

.measurements-page .ms-meta-form .ant-form-item {
  margin-bottom: var(--ds-space-3);
}

/* Dictation */
.measurements-page .ms-dictation {
  margin-bottom: var(--ds-space-4);
}

.measurements-page .ms-mic--active {
  animation: ms-pulse 1.4s var(--ds-ease) infinite;
}

@keyframes ms-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 color-mix(in srgb, var(--ds-danger) 45%, transparent);
  }
  50% {
    box-shadow: 0 0 0 8px transparent;
  }
}

.measurements-page .ms-interim {
  margin: var(--ds-space-2) 0 0;
  overflow-wrap: anywhere;
}

.measurements-page .ms-rec-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ds-danger);
  margin-inline-end: 4px;
  vertical-align: middle;
}

.measurements-page .ms-dictation-actions {
  margin-top: var(--ds-space-3);
}

.ms-found-room {
  line-height: 1.5;
}

.ms-unclear {
  margin: 0;
  padding-inline-start: 18px;
}

/* Rooms */
.measurements-page .ms-room-head {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  flex-wrap: wrap;
}

.measurements-page .ms-warn-icon {
  color: var(--ds-warning);
  margin-inline-start: 4px;
}

.measurements-page .ms-room-extra {
  /* Figures with units keep their order in right-to-left languages. */
  direction: ltr;
  unicode-bidi: isolate;
  color: var(--ds-text-2);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.measurements-page .ms-room .ms-field {
  margin-bottom: var(--ds-space-3);
}

.measurements-page .ms-room .ms-field .ant-form-item-label {
  padding-bottom: 2px;
}

.measurements-page .ms-room .ms-field .ant-input-number {
  width: 100%;
}

.measurements-page .ms-shape {
  margin-bottom: var(--ds-space-4);
}

.measurements-page .ms-hint {
  font-size: 13px;
  margin-bottom: var(--ds-space-3);
}

.measurements-page .ms-warning {
  margin-bottom: var(--ds-space-2);
}

.measurements-page .ms-divider {
  margin: var(--ds-space-4) 0 var(--ds-space-3);
}

.measurements-page .ms-item {
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  padding: var(--ds-space-3) var(--ds-space-3) 0;
  margin-bottom: var(--ds-space-2);
  background: var(--ds-surface-2);
}

.measurements-page .ms-add-row {
  margin-bottom: var(--ds-space-3);
}

.measurements-page .ms-room-actions {
  margin-top: var(--ds-space-3);
  flex-wrap: wrap;
}

/* Sketch */
.measurements-page .ms-sketch {
  display: block;
  width: 100%;
  max-height: 280px;
  aspect-ratio: 4 / 3;
  background: var(--ds-surface-2);
  border: 1px solid var(--ds-border-soft);
  border-radius: var(--ds-radius-md);
  margin-bottom: var(--ds-space-3);
}

.measurements-page .ms-sketch--empty {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--ds-space-4);
  color: var(--ds-text-muted);
  text-align: center;
  font-size: 13px;
}

.measurements-page .ms-sketch-floor {
  fill: var(--ds-brand-50);
}

.measurements-page .ms-sketch-wall {
  stroke: var(--ds-brand-ink);
  stroke-width: 2.5;
  stroke-linecap: round;
}

.measurements-page .ms-sketch-gap {
  stroke: var(--ds-danger);
  stroke-width: 2;
  stroke-dasharray: 6 4;
}

.measurements-page .ms-sketch-diagonal {
  stroke: var(--ds-brand);
  stroke-width: 1.5;
  stroke-dasharray: 6 4;
}

.measurements-page .ms-sketch-label {
  fill: var(--ds-text);
  font-family: var(--ds-font);
  font-variant-numeric: tabular-nums;
}

.measurements-page .ms-sketch-corner {
  fill: var(--ds-brand);
  font-weight: 700;
}

/* Figures */
.measurements-page .ms-figures {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: var(--ds-space-2);
  margin: var(--ds-space-3) 0 0;
}

.measurements-page .ms-figures > div {
  background: var(--ds-brand-50);
  border-radius: var(--ds-radius-md);
  padding: var(--ds-space-2) var(--ds-space-3);
}

.measurements-page .ms-figures dt {
  color: var(--ds-text-muted);
  font-size: 12px;
}

.measurements-page .ms-figures dd {
  margin: 0;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}

.measurements-page .ms-figures .ms-figures-wide {
  grid-column: 1 / -1;
}

.measurements-page .ms-figures .ms-figures-wide dd {
  font-weight: 400;
}

.measurements-page .ms-bottom-save {
  display: none;
}

@media (max-width: 767px) {
  .measurements-page .ms-header .ant-btn-primary {
    display: none;
  }

  /* Phones: one save button pinned above the bottom navigation. */
  .measurements-page .ms-bottom-save {
    display: block;
    position: sticky;
    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);
    z-index: 5;
    margin-top: var(--ds-space-3);
  }

  .measurements-page .ms-bottom-save .ant-btn {
    box-shadow: var(--ds-shadow-lg);
  }

  .measurements-page .ms-shape .ant-segmented-item-label {
    white-space: normal;
    line-height: 1.25;
    padding-block: 6px;
  }

  /* Phones: the room actions go under the title instead of squeezing it. */
  .measurements-page .ms-rooms .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: var(--ds-space-2);
    padding-block: var(--ds-space-2);
  }

  .measurements-page .ms-rooms .ant-card-extra {
    margin-inline-start: 0;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .measurements-page .ms-bottom-save {
    display: flex;
    justify-content: flex-end;
  }

  .measurements-page .ms-bottom-save .ant-btn {
    width: auto;
  }
}

/* Photo measuring (drawer) */
.photo-measure .ant-drawer-body {
  padding: var(--ds-space-3);
}

.photo-measure .pm-title {
  display: flex;
  flex-direction: column;
  line-height: 1.3;
  min-width: 0;
}

.photo-measure .pm-title .ant-typography {
  font-size: 12px;
  font-weight: 400;
  overflow-wrap: anywhere;
}

.photo-measure .pm-start {
  max-width: 520px;
  margin: var(--ds-space-4) auto;
}

.photo-measure .pm-start-actions {
  width: 100%;
  margin-bottom: var(--ds-space-4);
}

.photo-measure .pm-tips ul {
  margin: 0;
  padding-inline-start: 18px;
}

.photo-measure .pm-reference {
  margin-bottom: var(--ds-space-2);
}

.photo-measure .pm-swap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.photo-measure .pm-step {
  margin-bottom: var(--ds-space-2);
}

.photo-measure .pm-stage {
  position: relative;
  overflow: auto;
  max-height: 58vh;
  background: #111;
  border-radius: var(--ds-radius-md);
  touch-action: pan-x pan-y;
  -webkit-user-select: none;
  user-select: none;
}

.photo-measure .pm-canvas {
  position: relative;
  margin-inline: auto;
}

.photo-measure .pm-canvas img {
  display: block;
  width: 100%;
  height: auto;
  pointer-events: none;
}

.photo-measure .pm-canvas svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  cursor: crosshair;
}

.photo-measure .pm-ref {
  fill: color-mix(in srgb, var(--ds-logo-sky) 22%, transparent);
  stroke: var(--ds-logo-sky);
  stroke-width: 2;
}

.photo-measure .pm-ref--bad {
  fill: color-mix(in srgb, var(--ds-danger) 22%, transparent);
  stroke: var(--ds-danger);
}

.photo-measure .pm-line {
  stroke: #facc15;
  stroke-width: 2.5;
}

.photo-measure .pm-label {
  fill: #fff;
  stroke: rgba(0, 0, 0, 0.75);
  paint-order: stroke;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  pointer-events: none;
}

.photo-measure .pm-handle {
  fill: rgba(255, 255, 255, 0.25);
  stroke: #fff;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}

.photo-measure .pm-corner .pm-handle {
  stroke: var(--ds-logo-sky);
}

.photo-measure .pm-point .pm-handle {
  stroke: #facc15;
}

.photo-measure .pm-handle-dot {
  fill: #e11d48;
}

.photo-measure .pm-hit {
  fill: transparent;
  cursor: grab;
  touch-action: none;
}

.pm-loupe {
  position: fixed;
  z-index: 2000;
  width: 128px;
  height: 128px;
  border-radius: 50%;
  border: 3px solid #fff;
  box-shadow: var(--ds-shadow-lg);
  pointer-events: none;
  display: none;
}

.pm-loupe--on {
  display: block;
}

.photo-measure .pm-alert {
  margin-top: var(--ds-space-2);
}

.photo-measure .pm-results {
  list-style: none;
  margin: var(--ds-space-3) 0 0;
  padding: 0;
}

.photo-measure .pm-results li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--ds-space-2);
  padding: var(--ds-space-2) 0;
  border-bottom: 1px solid var(--ds-border-soft);
}

.photo-measure .pm-result-value {
  min-width: 0;
  font-variant-numeric: tabular-nums;
}

.photo-measure .pm-actions {
  margin-top: var(--ds-space-3);
}

/* Live AR overlay (WebXR DOM overlay) */
.ar-overlay {
  display: none;
}

.ar-overlay--on {
  display: block;
  position: fixed;
  inset: 0;
  z-index: 3000;
}

.ar-overlay .ar-canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ar-overlay .ar-hint {
  position: absolute;
  top: calc(var(--ds-safe-top) + 16px);
  inset-inline: 16px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.ar-overlay .ar-target {
  font-weight: 400;
  font-size: 13px;
  opacity: 0.9;
}

.ar-overlay .ar-distance {
  font-size: 32px;
  font-variant-numeric: tabular-nums;
  margin-top: 8px;
}

.ar-overlay .ar-controls {
  position: absolute;
  bottom: calc(var(--ds-safe-bottom) + 24px);
  inset-inline: 0;
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/measurements/measurements.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;;EAEE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,gCAAgC;AAClC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;IAEE,yEAAyE;EAC3E;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,oEAAoE;EACpE,cAAc;EACd,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;EAClC,8CAA8C;EAC9C,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,uCAAuC;EACvC,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,4DAA4D;EAC5D,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,gEAAgE;EAChE;IACE,cAAc;IACd,gBAAgB;IAChB,iEAAiE;IACjE,UAAU;IACV,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,yEAAyE;EACzE;IACE,eAAe;IACf,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["/* Aufmaß pages. Page rules are scoped to .measurements-page; the photo drawer\n   (.photo-measure) and the AR overlay (.ar-overlay) render outside the page. */\n\n.measurements-page .ms-small,\n.photo-measure .pm-small {\n  color: var(--ds-text-muted);\n  font-size: 12px;\n}\n\n.measurements-page .ms-full,\n.photo-measure .pm-full {\n  width: 100%;\n}\n\n.measurements-page .ms-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n/* Header */\n.measurements-page .ms-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-4);\n}\n\n.measurements-page .ms-title-input {\n  flex: 1;\n  min-width: 0;\n  font-family: var(--ds-font-display);\n  font-weight: 600;\n}\n\n.measurements-page .ms-meta-form .ant-form-item {\n  margin-bottom: var(--ds-space-3);\n}\n\n/* Dictation */\n.measurements-page .ms-dictation {\n  margin-bottom: var(--ds-space-4);\n}\n\n.measurements-page .ms-mic--active {\n  animation: ms-pulse 1.4s var(--ds-ease) infinite;\n}\n\n@keyframes ms-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 color-mix(in srgb, var(--ds-danger) 45%, transparent);\n  }\n  50% {\n    box-shadow: 0 0 0 8px transparent;\n  }\n}\n\n.measurements-page .ms-interim {\n  margin: var(--ds-space-2) 0 0;\n  overflow-wrap: anywhere;\n}\n\n.measurements-page .ms-rec-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ds-danger);\n  margin-inline-end: 4px;\n  vertical-align: middle;\n}\n\n.measurements-page .ms-dictation-actions {\n  margin-top: var(--ds-space-3);\n}\n\n.ms-found-room {\n  line-height: 1.5;\n}\n\n.ms-unclear {\n  margin: 0;\n  padding-inline-start: 18px;\n}\n\n/* Rooms */\n.measurements-page .ms-room-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  flex-wrap: wrap;\n}\n\n.measurements-page .ms-warn-icon {\n  color: var(--ds-warning);\n  margin-inline-start: 4px;\n}\n\n.measurements-page .ms-room-extra {\n  /* Figures with units keep their order in right-to-left languages. */\n  direction: ltr;\n  unicode-bidi: isolate;\n  color: var(--ds-text-2);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.measurements-page .ms-room .ms-field {\n  margin-bottom: var(--ds-space-3);\n}\n\n.measurements-page .ms-room .ms-field .ant-form-item-label {\n  padding-bottom: 2px;\n}\n\n.measurements-page .ms-room .ms-field .ant-input-number {\n  width: 100%;\n}\n\n.measurements-page .ms-shape {\n  margin-bottom: var(--ds-space-4);\n}\n\n.measurements-page .ms-hint {\n  font-size: 13px;\n  margin-bottom: var(--ds-space-3);\n}\n\n.measurements-page .ms-warning {\n  margin-bottom: var(--ds-space-2);\n}\n\n.measurements-page .ms-divider {\n  margin: var(--ds-space-4) 0 var(--ds-space-3);\n}\n\n.measurements-page .ms-item {\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  padding: var(--ds-space-3) var(--ds-space-3) 0;\n  margin-bottom: var(--ds-space-2);\n  background: var(--ds-surface-2);\n}\n\n.measurements-page .ms-add-row {\n  margin-bottom: var(--ds-space-3);\n}\n\n.measurements-page .ms-room-actions {\n  margin-top: var(--ds-space-3);\n  flex-wrap: wrap;\n}\n\n/* Sketch */\n.measurements-page .ms-sketch {\n  display: block;\n  width: 100%;\n  max-height: 280px;\n  aspect-ratio: 4 / 3;\n  background: var(--ds-surface-2);\n  border: 1px solid var(--ds-border-soft);\n  border-radius: var(--ds-radius-md);\n  margin-bottom: var(--ds-space-3);\n}\n\n.measurements-page .ms-sketch--empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--ds-space-4);\n  color: var(--ds-text-muted);\n  text-align: center;\n  font-size: 13px;\n}\n\n.measurements-page .ms-sketch-floor {\n  fill: var(--ds-brand-50);\n}\n\n.measurements-page .ms-sketch-wall {\n  stroke: var(--ds-brand-ink);\n  stroke-width: 2.5;\n  stroke-linecap: round;\n}\n\n.measurements-page .ms-sketch-gap {\n  stroke: var(--ds-danger);\n  stroke-width: 2;\n  stroke-dasharray: 6 4;\n}\n\n.measurements-page .ms-sketch-diagonal {\n  stroke: var(--ds-brand);\n  stroke-width: 1.5;\n  stroke-dasharray: 6 4;\n}\n\n.measurements-page .ms-sketch-label {\n  fill: var(--ds-text);\n  font-family: var(--ds-font);\n  font-variant-numeric: tabular-nums;\n}\n\n.measurements-page .ms-sketch-corner {\n  fill: var(--ds-brand);\n  font-weight: 700;\n}\n\n/* Figures */\n.measurements-page .ms-figures {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: var(--ds-space-2);\n  margin: var(--ds-space-3) 0 0;\n}\n\n.measurements-page .ms-figures > div {\n  background: var(--ds-brand-50);\n  border-radius: var(--ds-radius-md);\n  padding: var(--ds-space-2) var(--ds-space-3);\n}\n\n.measurements-page .ms-figures dt {\n  color: var(--ds-text-muted);\n  font-size: 12px;\n}\n\n.measurements-page .ms-figures dd {\n  margin: 0;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  overflow-wrap: anywhere;\n}\n\n.measurements-page .ms-figures .ms-figures-wide {\n  grid-column: 1 / -1;\n}\n\n.measurements-page .ms-figures .ms-figures-wide dd {\n  font-weight: 400;\n}\n\n.measurements-page .ms-bottom-save {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .measurements-page .ms-header .ant-btn-primary {\n    display: none;\n  }\n\n  /* Phones: one save button pinned above the bottom navigation. */\n  .measurements-page .ms-bottom-save {\n    display: block;\n    position: sticky;\n    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + 8px);\n    z-index: 5;\n    margin-top: var(--ds-space-3);\n  }\n\n  .measurements-page .ms-bottom-save .ant-btn {\n    box-shadow: var(--ds-shadow-lg);\n  }\n\n  .measurements-page .ms-shape .ant-segmented-item-label {\n    white-space: normal;\n    line-height: 1.25;\n    padding-block: 6px;\n  }\n\n  /* Phones: the room actions go under the title instead of squeezing it. */\n  .measurements-page .ms-rooms .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    gap: var(--ds-space-2);\n    padding-block: var(--ds-space-2);\n  }\n\n  .measurements-page .ms-rooms .ant-card-extra {\n    margin-inline-start: 0;\n    width: 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .measurements-page .ms-bottom-save {\n    display: flex;\n    justify-content: flex-end;\n  }\n\n  .measurements-page .ms-bottom-save .ant-btn {\n    width: auto;\n  }\n}\n\n/* Photo measuring (drawer) */\n.photo-measure .ant-drawer-body {\n  padding: var(--ds-space-3);\n}\n\n.photo-measure .pm-title {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.3;\n  min-width: 0;\n}\n\n.photo-measure .pm-title .ant-typography {\n  font-size: 12px;\n  font-weight: 400;\n  overflow-wrap: anywhere;\n}\n\n.photo-measure .pm-start {\n  max-width: 520px;\n  margin: var(--ds-space-4) auto;\n}\n\n.photo-measure .pm-start-actions {\n  width: 100%;\n  margin-bottom: var(--ds-space-4);\n}\n\n.photo-measure .pm-tips ul {\n  margin: 0;\n  padding-inline-start: 18px;\n}\n\n.photo-measure .pm-reference {\n  margin-bottom: var(--ds-space-2);\n}\n\n.photo-measure .pm-swap {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.photo-measure .pm-step {\n  margin-bottom: var(--ds-space-2);\n}\n\n.photo-measure .pm-stage {\n  position: relative;\n  overflow: auto;\n  max-height: 58vh;\n  background: #111;\n  border-radius: var(--ds-radius-md);\n  touch-action: pan-x pan-y;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n.photo-measure .pm-canvas {\n  position: relative;\n  margin-inline: auto;\n}\n\n.photo-measure .pm-canvas img {\n  display: block;\n  width: 100%;\n  height: auto;\n  pointer-events: none;\n}\n\n.photo-measure .pm-canvas svg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  cursor: crosshair;\n}\n\n.photo-measure .pm-ref {\n  fill: color-mix(in srgb, var(--ds-logo-sky) 22%, transparent);\n  stroke: var(--ds-logo-sky);\n  stroke-width: 2;\n}\n\n.photo-measure .pm-ref--bad {\n  fill: color-mix(in srgb, var(--ds-danger) 22%, transparent);\n  stroke: var(--ds-danger);\n}\n\n.photo-measure .pm-line {\n  stroke: #facc15;\n  stroke-width: 2.5;\n}\n\n.photo-measure .pm-label {\n  fill: #fff;\n  stroke: rgba(0, 0, 0, 0.75);\n  paint-order: stroke;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  pointer-events: none;\n}\n\n.photo-measure .pm-handle {\n  fill: rgba(255, 255, 255, 0.25);\n  stroke: #fff;\n  stroke-width: 2;\n  vector-effect: non-scaling-stroke;\n}\n\n.photo-measure .pm-corner .pm-handle {\n  stroke: var(--ds-logo-sky);\n}\n\n.photo-measure .pm-point .pm-handle {\n  stroke: #facc15;\n}\n\n.photo-measure .pm-handle-dot {\n  fill: #e11d48;\n}\n\n.photo-measure .pm-hit {\n  fill: transparent;\n  cursor: grab;\n  touch-action: none;\n}\n\n.pm-loupe {\n  position: fixed;\n  z-index: 2000;\n  width: 128px;\n  height: 128px;\n  border-radius: 50%;\n  border: 3px solid #fff;\n  box-shadow: var(--ds-shadow-lg);\n  pointer-events: none;\n  display: none;\n}\n\n.pm-loupe--on {\n  display: block;\n}\n\n.photo-measure .pm-alert {\n  margin-top: var(--ds-space-2);\n}\n\n.photo-measure .pm-results {\n  list-style: none;\n  margin: var(--ds-space-3) 0 0;\n  padding: 0;\n}\n\n.photo-measure .pm-results li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: var(--ds-space-2);\n  padding: var(--ds-space-2) 0;\n  border-bottom: 1px solid var(--ds-border-soft);\n}\n\n.photo-measure .pm-result-value {\n  min-width: 0;\n  font-variant-numeric: tabular-nums;\n}\n\n.photo-measure .pm-actions {\n  margin-top: var(--ds-space-3);\n}\n\n/* Live AR overlay (WebXR DOM overlay) */\n.ar-overlay {\n  display: none;\n}\n\n.ar-overlay--on {\n  display: block;\n  position: fixed;\n  inset: 0;\n  z-index: 3000;\n}\n\n.ar-overlay .ar-canvas {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n}\n\n.ar-overlay .ar-hint {\n  position: absolute;\n  top: calc(var(--ds-safe-top) + 16px);\n  inset-inline: 16px;\n  text-align: center;\n  color: #fff;\n  font-weight: 600;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n.ar-overlay .ar-target {\n  font-weight: 400;\n  font-size: 13px;\n  opacity: 0.9;\n}\n\n.ar-overlay .ar-distance {\n  font-size: 32px;\n  font-variant-numeric: tabular-nums;\n  margin-top: 8px;\n}\n\n.ar-overlay .ar-controls {\n  position: absolute;\n  bottom: calc(var(--ds-safe-bottom) + 24px);\n  inset-inline: 0;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
